import { StyleRoot } from "@redotech/react-util/style";
import { WidgetAutocheck } from "@redotech/redo-model/widget";
import { createRoot } from "react-dom/client";
import { StorefrontClient } from "../client/storefront";
import { log } from "../monitoring/log";
import { RedoRoot } from "../root";
import STYLE_MANAGER from "../style-manager";
import { TryFirstProvider } from "./context";
import { TryFirstButton } from "./try-first-button";

export function isTryFirstSetup(autocheck: WidgetAutocheck) {
  return autocheck.tryFirst?.sellingPlanId;
}

export function initialize(
  autocheck: WidgetAutocheck,
  extensionShopifyClient: StorefrontClient,
) {
  log("Initializing Try First...");

  const elements = document.querySelectorAll(".redo-try-first-button");

  log(`Found ${elements.length} try first containers`);

  if (elements.length === 0) {
    return;
  }

  const storeUrl =
    window.redoStorefront?.storeUrl ??
    window.Shopify?.shop ??
    window.Shopify?.Checkout?.apiHost;

  for (const element of elements) {
    // Shopify applies display: none to empty divs
    (element as HTMLElement).style.display = "unset";

    const root = createRoot(element);
    root.render(
      <StyleRoot container={element} styleManager={STYLE_MANAGER}>
        <RedoRoot
          extensionShopifyClient={extensionShopifyClient}
          storeUrl={storeUrl}
        >
          <TryFirstProvider
            autocheck={autocheck}
            container={element as HTMLElement}
            extensionShopifyClient={extensionShopifyClient}
          >
            <TryFirstButton />
          </TryFirstProvider>
        </RedoRoot>
      </StyleRoot>,
    );
  }
}
